<template>
  <div class="container">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <fai icon="file-contract"/>&nbsp;Editar Contrato {{ contract.folio }}
        </div>
      </div>
      <div class="card-body pb-5">
        <!--begin: Details -->
          <div class="row mt-4">
            <div class="col-sm-6">
              <h4 class="font-info">Datos Generales</h4>
            </div>
          </div>
          <sys-form :inputs="contract_details" v-if="loaded"/><hr class="mt-5">
          <div v-if="isMixedRate">
            <sys-form :inputs="mixed_rate" v-if="loaded"/><hr class="mt-5">
          </div>
          <sys-form :inputs="bank" v-if="loaded"/>
        <!--end: Details -->
      </div>
      <div class="card-footer text-right">
        <button class="btn btn-secondary" @click="$router.go(-1)">
          <fai icon="reply"/> Cancelar
        </button>
        <button class="btn btn-success" :class="{ 'disabled': form.isSaving }" @click="saveForm">
          <fai :icon="['far','edit']"/> Guardar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import contractsService from '@/services/contracts'
import investorsService from '@/services/investors'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'

export default {
  components: { SysForm },

  mixins: [ formMixin ],

  data () {
    return {
      loaded: false,
      contract: {},
      contract_details: {
        investor_id: {
          name: 'Acreedor',
          hint: 'Selecciona un Acreedor',
          value: null,
          type: 'select',
          options: [],
          size: 8,
          validate: 'required'
        },
        contract_type_id: {
          name: 'Tipo',
          hint: 'Seleccione el tipo',
          value: null,
          type: 'select',
          options: [],
          validate: 'required'
        },
        interest_rate: {
          name: 'Tasa de Interés (%)',
          hint: 'Tasa de interés',
          value: '',
          min: 0,
          max: 100,
          type: 'number',
          validate: 'required'
        },
        date_init: {
          name: 'Fecha de Inicio',
          hint: 'dd/mm/aaaa',
          value: '',
          type: 'date',
          validate: 'required'
        },
        frequency_id: {
          name: 'Frecuencia de Pago',
          hint: 'Sellecione la frecuencia de pago',
          value: null,
          type: 'select',
          options: [],
          validate: 'required'
        },
        cut_day: {
          name: 'Día de corte',
          hint: 'Selecione un día',
          value: null,
          type: 'select',
          options: [
            { value: 7, text: '7' },
            { value: 15, text: '15' },
            { value: 21, text: '21' },
            { value: 'last_day', text: 'Último del mes' }
          ],
          validate: 'required'
        },
        payment_method_id: {
          name: 'Método de Pago',
          hint: 'Selecciona un Método de Pago',
          value: null,
          type: 'select',
          options: [],
          size: 4
        }
      },
      mixed_rate: {
        1: {
          name: 'Efectivo',
          hint: 'Selecciona una parte del interes',
          value: null,
          type: 'number',
          min: 0,
          max: 100
        },
        2: {
          name: 'Transferencia Bancaria',
          hint: 'Selecciona una parte del interes',
          value: null,
          type: 'number',
          min: 0,
          max: 100
        },
        3: {
          name: 'Cheque',
          hint: 'Selecciona una parte del interes',
          value: null,
          type: 'number',
          min: 0,
          max: 100
        }
      },
      bank: {
        bank_account_id: {
          name: 'Cuenta Bancaria',
          hint: 'Selecciona una cuenta bancaria',
          value: null,
          type: 'select',
          options: [],
          size: 12
        }
      },
      bank_accounts: {}
    }
  },

  created: function () {
    contractsService.getById(this.$route.params.id).then(res => {
      this.contract = res.data

      Object.keys(this.contract_details).forEach(key => {
        this.contract_details[key].value = this.contract[key]

        if (this.contract.rates.length) {
          Object.keys(this.contract.rates).forEach(key => {
            if (this.contract.rates[key].payment_method_id == 1) {
              this.mixed_rate[1].value = this.contract.rates[key].interest_rate
            } else if (this.contract.rates[key].payment_method_id == 2) {
              this.mixed_rate[2].value = this.contract.rates[key].interest_rate
            } else if (this.contract.rates[key].payment_method_id == 3) {
              this.mixed_rate[3].value = this.contract.rates[key].interest_rate
            }
          })
        }
      })

      this.contract_details.date_init.value = this.contract.date_init.split('-').reverse().join('-')

      investorsService.withContracts().then(res => {
        this.contract_details.investor_id.options = res.map(investor => {
          return { value: investor.id, text: investor.fullname }
        })
      })

      this.contract_details.investor_id.value = { value: this.contract.investor_id, text: this.contract.investor_name }

      if (this.contract.bank_account_id) {
        this.bank.bank_account_id.value = {
          value: this.contract.bank_account_id,
          text: `${this.contract.bank_data.bank}, ${this.contract.bank_data.account}, ${this.contract.bank_data.clabe}`
        }
      }

      contractsService.getTypes().then(res => {
        this.contract_types = res.data.map(data => {
          return { value: data.id, text: `${data.name} (${data.code})` }
        })
        this.contract_details.contract_type_id.options = this.contract_types
        this.contract_details.contract_type_id.value = this.contract_types.reduce((result, contractType) => {
          if (contractType.value == this.contract.contract_type_id) result = contractType
          return result || null
        }, null)
      })

      contractsService.getFrequencies().then(res => {
        this.frequencies = res.data.map(data => {
          return { value: data.id, text: `${data.name}` }
        })
        this.contract_details.frequency_id.options = this.frequencies
        this.contract_details.frequency_id.value = this.contract_details.frequency_id.options.reduce((result, frequency) => {
          if (frequency.value == this.contract.frequency_id) result = frequency
          return result || null
        }, null)
      })
      contractsService.getPaymentMethods().then(res => {
        this.payment_methods = res.data.map(data => {
          return { value: data.id, text: `${data.name}` }
        })
        this.contract_details.payment_method_id.options = this.payment_methods
        this.contract_details.payment_method_id.value = this.contract_details.payment_method_id.options.reduce((result, paymentMethod) => {
          if (paymentMethod.value == this.contract.payment_method_id) result = paymentMethod
          return result || null
        }, null)
      })

      this.contract_details.cut_day.value = this.contract_details.cut_day.options.reduce((result, cutDay) => {
        if (cutDay.value == this.contract.cut_day_id) result = cutDay
        return result || null
      }, null)
      this.loaded = true
    })
  },

  methods: {
    saveForm: function () {
      if (this.form.saving) return

      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = this.processForm(this.contract_details)
          const bankAccount = this.processForm(this.bank)

          body = { ...body, ...bankAccount }

          if (this.isMixedRate) body['mixed_rate'] = this.processForm(this.mixed_rate)

          let service = contractsService.updateById(this.contract.id, body)

          this.sendForm(service).then(res => {
            this.$router.push({ name: 'contracts', props: { contract: res } })
          }).catch(err => {
            console.log(JSON.stringify(err.statusText))
          })
        }
      })
    }
  },

  watch: {
    'contract_details.investor_id.value': function (newInvestor, oldInvestor) {
      investorsService.banks(newInvestor.value).then(res => {
        this.bank.bank_account_id.options = res.map(bank => {
          return {
            value: bank.id,
            text: `${bank.bank}, ${bank.account}, ${bank.clabe}`
          }
        })
      })
    }
  },

  computed: {
    isMixedRate: function () {
      const type = this.contract_details.contract_type_id.value
      if (type && type.value == 2) return true
      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contracts/ContractUpdate.vue